export const BENEFITS_GROUP = 'benefits';
export const COMMUNICATION_GROUP = 'communication';
export const LEGAL_GROUP = 'legal';

// rules

export const RULE_PROP_REQUIRE = 'require';
export const RULE_PROP_RENDER = 'render';
export const RULE_PROP_PERMISSION = 'permission';

// actions

export const ADD_POINTS_ACTION = 'addPoints';
export const DEDUCT_POINTS_ACTION = 'deductPoints';
export const ASSIGN_ASSET_ACTION = 'assignAsset';
export const REMOVE_ASSET_ACTION = 'unassignAsset';
export const REDEEM_ASSET_ACTION = 'redeemAsset';
export const AUTO_PUNCH_ACTION = 'punch';
export const EXTEND_ASSET_ACTION = 'extendAsset';

export const SEND_PERSONAL_PUSH_ACTION = 'sendPersonalPush';
export const SEND_MESSAGE_ACTION = 'sendMessage';
export const SEND_MEMBER_SMS_ACTION = 'sendMemberSms';
export const SEND_MEMBER_EMAIL_ACTION = 'sendMemberEmail';

export const REMOTE_LOGOUT_ACTION = 'remoteLogout';
export const DELETE_MEMBER_ACTION = 'deleteMember';
export const SEND_DATA_REPORT_ACTION = 'sendDataReport';
export const SEND_TC_CONSENT_SMS_OR_EMAIL_ACTION = 'sendTcConsentSmsOrEmail';
export const GAVE_CONSENT = 'gaveConsent';
export const UNSUBSCRIBE_SMS_ACTION = 'unsubscribeSMS';
export const UNSUBSCRIBE_EMAIL_ACTION = 'unsubscribeEmail';

export const ADD_POINTS_WALLET_POINTS = 'Points';
export const ADD_POINTS_WALLET_BUDGET = 'Credit';
export const ADD_POINTS_BUDGET = 'Budget';
export const ADD_POINTS_WALLET_BOTH = 'Both';

export const ASSIGN_ASSET_BENEFIT_KEY_FIELD = 'benefitKey';
export const BUDGET_TYPE = 'Both';

export const CONSENT_TYPE = 'consentType';
export const SEND_CONSENT_BY_SMS = 'sendConsentBySms';
export const SEND_CONSENT_BY_EMAIL = 'sendConsentByEmail';
export const EMAIL_MESSAGE = 'emailMessage';
export const EMAIL_SUBJECT = 'emailSubject';

export const MENTION_ID = 'id';
export const MENTION_CATEGORY = 'category';
export const MENTION_DEFAULT_SMS_LENGTH = 'smsLength';
export const DATE_MENTION_LENGTH = 10;
export const DATE_AND_TIME_MENTION_LENGTH = 21;
export const TEXT_MENTION_LENGTH = 21;
export const NUMBER_MENTION_LENGTH = 5;

export const SMS_MESSAGE = 'message';
export const PUSH_MESSAGE = 'message';
export const POPUP_MESSAGE = 'message';
export const POPUP_SUBJECT = 'subject';
export const NUMBER_OF_MESSAGES = 'numberOfMessages';
export const MESSAGE_CONTENT_LENGTH = 'messageContentLength';

// MEMBERSHIP
export const CONTEXT_SHARE_BUDGET_RECEIVER = 'context.Data.receiver';
export const CONTEXT_SHARE_BUDGET_SENDER = 'context.Data.sender';
export const CONTEXT_SHARE_BUDGET_AMOUNT = 'context.Data.amount';
export const CONTEXT_SHARE_BUDGET_TYPE = 'context.Data.wallet';
export const CONTEXT_SHARE_BUDGET_LINK = 'context.Data.budgetTransferLink';
export const CONTEXT_MEMBERSHIP_ADDRESS_CITY = 'context.Membership.AddressCity';
export const CONTEXT_MEMBERSHIP_ADDRESS_COUNTRY = 'context.Membership.AddressCountry';
export const CONTEXT_MEMBERSHIP_ADDRESS_FLOOR = 'context.Membership.AddressFloor';
export const CONTEXT_MEMBERSHIP_ADDRESS_HOME = 'context.Membership.AddressHome';
export const CONTEXT_MEMBERSHIP_ADDRESS_LINE_1 = 'context.Membership.AddressLine1';
export const CONTEXT_MEMBERSHIP_ADDRESS_LINE_2 = 'context.Membership.AddressLine2';
export const CONTEXT_MEMBERSHIP_ADDRESS_STATE = 'context.Membership.AddressState';
export const CONTEXT_MEMBERSHIP_ADDRESS_STREET = 'context.Membership.AddressStreet';
export const CONTEXT_MEMBERSHIP_ADDRESS_ZIP_CODE = 'context.Membership.AddressZipCode';
export const CONTEXT_MEMBERSHIP_ALLOW_EMAIL = 'context.Membership.AllowEmail';
export const CONTEXT_MEMBERSHIP_ALLOW_SMS = 'context.Membership.AllowSMS';
export const CONTEXT_MEMBERSHIP_ANNIVERSARY = 'context.Membership.Anniversary';
export const CONTEXT_MEMBERSHIP_ANNIVERSARY_MONTH = 'context.Membership.AnniversaryMonth';
export const CONTEXT_MEMBERSHIP_BIRTHDAY = 'context.Membership.Birthday';
export const CONTEXT_MEMBERSHIP_BIRTHDAY_MONTH = 'context.Membership.BirthdayMonth';
export const CONTEXT_MEMBERSHIP_BUDGETWEIGHTED = 'context.Membership.BudgetWeighted';
export const CONTEXT_MEMBERSHIP_EMAIL = 'context.Membership.Email';
export const CONTEXT_MEMBERSHIP_EXPIRATION_DATE = 'context.Membership.ExpirationDate';
export const CONTEXT_MEMBERSHIP_EXT_CLUB_MEMBER_ID = 'context.Membership.ExtClubMemberID';
export const CONTEXT_MEMBERSHIP_FAVORITE_BRANCH_ID = 'context.Membership.FavoriteBranchID';
export const CONTEXT_MEMBERSHIP_FIRST_NAME = 'context.Membership.FirstName';
export const CONTEXT_MEMBERSHIP_FIRST_NAME_CI = 'caseInsensitive.context.Membership.FirstName';
export const CONTEXT_MEMBERSHIP_GENDER = 'context.Membership.Gender';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_1 = 'context.Membership.GenericCheckBox1';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_2 = 'context.Membership.GenericCheckBox2';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_3 = 'context.Membership.GenericCheckBox3';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_4 = 'context.Membership.GenericCheckBox4';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_5 = 'context.Membership.GenericCheckBox5';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_6 = 'context.Membership.GenericCheckBox6';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_7 = 'context.Membership.GenericCheckBox7';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_8 = 'context.Membership.GenericCheckBox8';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_9 = 'context.Membership.GenericCheckBox9';
export const CONTEXT_MEMBERSHIP_GENERIC_CHECKBOX_10 = 'context.Membership.GenericCheckBox10';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_1 = 'context.Membership.GenericDate1';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_2 = 'context.Membership.GenericDate2';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_3 = 'context.Membership.GenericDate3';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_4 = 'context.Membership.GenericDate4';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_5 = 'context.Membership.GenericDate5';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_6 = 'context.Membership.GenericDate6';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_7 = 'context.Membership.GenericDate7';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_8 = 'context.Membership.GenericDate8';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_9 = 'context.Membership.GenericDate9';
export const CONTEXT_MEMBERSHIP_GENERIC_DATE_10 = 'context.Membership.GenericDate10';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_1 = 'context.Membership.GenericInteger1';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_2 = 'context.Membership.GenericInteger2';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_3 = 'context.Membership.GenericInteger3';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_4 = 'context.Membership.GenericInteger4';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_5 = 'context.Membership.GenericInteger5';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_6 = 'context.Membership.GenericInteger6';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_7 = 'context.Membership.GenericInteger7';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_8 = 'context.Membership.GenericInteger8';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_9 = 'context.Membership.GenericInteger9';
export const CONTEXT_MEMBERSHIP_GENERIC_INTEGER_10 = 'context.Membership.GenericInteger10';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_1 = 'context.Membership.GenericString1';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_2 = 'context.Membership.GenericString2';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_3 = 'context.Membership.GenericString3';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_4 = 'context.Membership.GenericString4';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_5 = 'context.Membership.GenericString5';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_6 = 'context.Membership.GenericString6';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_7 = 'context.Membership.GenericString7';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_8 = 'context.Membership.GenericString8';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_9 = 'context.Membership.GenericString9';
export const CONTEXT_MEMBERSHIP_GENERIC_STRING_10 = 'context.Membership.GenericString10';
export const CONTEXT_MEMBERSHIP_GOV_ID = 'context.Membership.GovID';
export const CONTEXT_MEMBERSHIP_HAS_CONSENT = 'context.Membership.ConsentForHub';
export const CONTEXT_MEMBERSHIP_HOME_BRANCH_ID = 'context.Membership.HomeBranchID';
export const CONTEXT_MEMBERSHIP_LAST_NAME = 'context.Membership.LastName';
export const CONTEXT_MEMBERSHIP_LAST_NAME_CI = 'caseInsensitive.context.Membership.LastName';
export const CONTEXT_MEMBERSHIP_LAST_VISIT = 'context.Membership.MembershipLastVisitTag';
export const CONTEXT_MEMBERSHIP_LOCATION_ENABLED = 'context.Membership.LocationEnabled';
export const CONTEXT_MEMBERSHIP_MEMBER_ID = 'context.Membership.MemberID';
export const CONTEXT_MEMBERSHIP_MOBILE_APP_USED = 'context.Membership.MobileAppUsed';
export const CONTEXT_MEMBERSHIP_PHONE_NUMBER = 'context.Membership.PhoneNumber';
export const CONTEXT_MEMBERSHIP_POINTS = 'context.Membership.Points';
export const CONTEXT_MEMBERSHIP_PREFERRED_LOCATION = 'context.Membership.MembershipPreferredLocationTag';
export const CONTEXT_MEMBERSHIP_PUSH_NOTIFICATION_ENABLED = 'context.Membership.PushNotificationEnabled';
export const CONTEXT_MEMBERSHIP_RFM = 'context.Membership.MembershipRfmTag';
export const CONTEXT_MEMBERSHIP_SECOND_PREFERRED_LOCATION = 'context.Membership.MembershipSecondPreferredLocationTag';
export const CONTEXT_MEMBERSHIP_STATUS = 'context.Membership.MembershipStatus';
export const CONTEXT_MEMBERSHIP_STORED_CREDIT_CARD = 'context.Membership.StoredCreditCard';
export const CONTEXT_MEMBERSHIP_TAG = 'context.Membership.Tag';
export const CONTEXT_MEMBERSHIP_TERMS_OF_USE_DATE = 'context.Membership.TermsOfUseDate';

// CONDITIONS
export const CONTEXT_EVENT_TIME = 'context.EventTime';
export const CONTEXT_PURCHASE_TOTAL_SUM = 'context.Purchase.TotalSum';
export const CONTEXT_PURCHASE_BRANCH_ID = 'context.Purchase.BranchID';
export const CONTEXT_PURCHASE_POS_ID = 'context.Purchase.PosID';
export const CONTEXT_PURCHASE_NUMBER_OF_MEMBERS = 'context.Purchase.NumOfMembers';
export const CONTEXT_PURCHASE_TAGS = 'context.Purchase.Tags';
export const CONTEXT_PURCHASE_TRANSACTION_SOURCE = 'context.Purchase.TransactionSource';
export const CONTEXT_PURCHASE_TRANSACTION_SOURCE_NAME = 'context.Purchase.TransactionSourceName';
export const CONTEXT_PURCHASE_CASHIER = 'context.Purchase.Cashier';
export const CONTEXT_ITEM_PRICE = 'context.ItemPrice';
export const CONTEXT_PAYMENT_FLOW = 'context.PaymentFlow';
export const CONTEXT_ACTUAL_CHARGE = 'context.ActualCharge';
export const CONTEXT_ASSET_TEMPLATE = 'context.Asset.Template';
export const CONTEXT_REDEEM_ASSET_TEMPLATE = 'redeem.asset.template';
export const CONTEXT_PUNCH_ASSET_TEMPLATE = 'punch.asset.template';
export const CONTEXT_ASSET_DATA_SOURCE = 'context.SourceDataSource';
export const CONTEXT_NUM_OF_PUNCHES = 'context.NumOfPunches';
export const CONTEXT_TOTAL_PUNCHES_AFTER_OPERATION = 'context.TotalPunchesAfterOperation';
export const CONTEXT_LAST_PUNCH = 'context.LastPunch';
export const CONTEXT_USED_REFERRAL_CODE = 'context.Referred';
export const CONTEXT_REFERRAL_DATA = 'context.ReferralData';
export const CONTEXT_JOIN_SOURCE = 'context.Source';
export const CONTEXT_DATA_AMOUNTS_POINTS = 'context.Data.Amounts.Points';
export const CONTEXT_DATA_AMOUNTS_BUDGET_WEIGHTED = 'context.Data.Amounts.BudgetWeighted';
export const CONTEXT_DATA_NEW_POINTS_SET_POINTS = 'context.Data.NewPointsSet.Points';
export const CONTEXT_DATA_NEW_POINTS_SET_BUDGET_WEIGHTED = 'context.Data.NewPointsSet.BudgetWeighted';
export const CONTEXT_CATALOG_ITEM = 'context.Catalog.Item';
export const CONTEXT_TAG = 'context.Tag';
export const CONTEXT_FORM_ID = 'context.formId';
export const CONTEXT_DATA_SUB_TYPE = 'context.Data.SubType';
export const CONTEXT_DATA_DATA_UUID = 'context.Data.Data.uuid';
export const CONTEXT_DATA_DATA_MAJOR = 'context.Data.Data.major';
export const CONTEXT_DATA_DATA_MINOR = 'context.Data.Data.minor';
export const CONTEXT_DATA_TYPE = 'context.Data.Type';
export const CONTEXT_DATA_DATA_STRING_VALUE_1 = 'context.Data.Data.StringValue1';
export const CONTEXT_DATA_DATA_STRING_VALUE_2 = 'context.Data.Data.StringValue2';
export const CONTEXT_DATA_DATA_NUMERIC_VALUE_1 = 'context.Data.Data.NumericValue1';
export const CONTEXT_DATA_DATA_NUMERIC_VALUE_2 = 'context.Data.Data.NumericValue2';
export const CONTEXT_DATA_DATA_DATE_VALUE_1 = 'context.Data.Data.DateValue1';
export const CONTEXT_DATA_DATA_DATE_VALUE_2 = 'context.Data.Data.DateValue2';
export const CONTEXT_DATA_DATA_BOOLEAN_VALUE_1 = 'context.Data.Data.BooleanValue1';
export const CONTEXT_DATA_DATA_BOOLEAN_VALUE_2 = 'context.Data.Data.BooleanValue2';
export const CONTEXT_SHOPPING_CART_TOTAL_QUANTITY = 'shoppingCart.TotalQuantity';
export const CONTEXT_SHOPPING_CART_TOTAL_PRICE = 'shoppingCart.TotalPrice';
export const USER_ACTIONS_QUANTITY = 'resultsNum';
export const USER_ACTIONS_NUM_OF_PURCHASES = 'num.of.purchases';
export const TOTAL_SUM_OF_ALL_PURCHASES = 'all.purchases.total.sum';
export const CONTEXT_PAYMENT_TYPES = 'context.PaymentTypes';
export const CONDITION_KEY_BRANCH_ID = 'branchId';
export const CONTEXT_TIMESTAMP = 'context.TimeStamp';
export const CONTEXT_TIMESTAMP_DAYS = 'context.TimeStampDays';
export const CONTEXT_AVAILABLE_PUNCH_CARD = 'context.AvailablePunchCard';
export const CONTEXT_EXPIRED_PUNCH_CARD = 'context.ExpiredPunchCard';
export const CONTEXT_MEMBERSHIP_KEY_STR = 'context.MembershipKey';
export const MEMBERSHIP_KEYS_FILE = 'membershipKeysFile';
export const EMAIL_RECEIVED_SUCCESSFULLY = 'email.receivedSuccessfully';
export const EMAIL_SENT_FROM = 'email.sentFrom';
export const EMAIL_TEMPLATE = 'email.template';
export const EMAIL_OPENED = 'email.opened';
export const EMAIL_CLICKED = 'email.clicked';
export const PROBABILITY = 'probability';
export const CASES_ONLY_CONDITION = 'casesOnlyCondition';

export const MENTION_MEMBERSHIP_CATEGORY = 'Membership';
export const MENTION_MEMBERSHIP_BY_REG_FORM_CATEGORY = 'MembershipByRegForm';
export const MENTION_MEMBERSHIP_ADDRESS_CATEGORY = 'MembershipAddress';
export const MENTION_MEMBERSHIP_ALWAYS_SHOW_CATEGORY = 'MembershipAlwaysShow';
export const MENTION_MEMBERSHIP_EXTERNAL_EVENT_CATEGORY = 'ExternalEvent';
export const MENTION_MEMBERSHIP_PURCHASE_CATEGORY = 'Purchase';
export const MENTION_MEMBERSHIP_JOIN_CLUB_CATEGORY = 'JoinClub';
export const MENTION_UPDATE_MEMBERSHIP_CATEGORY = 'UpdateMembership';
export const MENTION_SHARE_BUDGET_CATEGORY = 'ShareBudget';

export const CONSENT_LANDING_PAGE_LINK_MENTION = '@Consent.LandingPageLink';
export const ASSIGN_ASSET_QUANTITY_FIELD = 'quantity';
export const POINTS = 'points';
export const TYPE = 'type';
export const ACCUMULATE_POINTS_TYPE_FIXED = 'fixed';

export const MESSAGE_TRIGGER_BY = 'messageTriggetBy';
export const MESSAGE_TRIGGER_BY_OPENING_THE_APP = 'messageTriggerByOpeningTheApp';
export const MESSAGE_TRIGGER_BY_NAVIGATION_TO_HOME_SCREEN = 'messageTriggerByNavigationToHomeScreen';
export const MESSAGE_TRIGGER_BY_AFTER_REDEEM = 'messageTriggerByAfterRedeem';
export const MESSAGE_TRIGGER_BY_AFTER_PUNCH = 'messageTriggerByAfterPunch';
export const MESSAGE_TRIGGER_BY_AFTER_COUPON_CODE_ACTION = 'messageTriggerByAfterCouponCodeAction';
export const SAVE_MESSAGE_TO_INBOX = 'saveMessageToInbox';
export const MESSAGE_MAX_AGE_IN_DAYS = 'messageMaxAgeInDays';
export const GENERIC_ACTION_ARGS = 'genericActionArgs';
